<div
  class="m-auto grid grid-flow-row gap-3 items-start box-border py-5 px-9 overflow-hidden relative w-[1243px] max-w-[1243px]"
>
  <div
    class="flex justify-between items-center min-w-[600px] w-full mb-[36px] mt-7"
  >
    <ui-paragraph
      type="p18"
      mobile-type="p18"
      text-color="neutrals-900"
      font-weight="semibold"
    >
      Respuestas Rápidas
    </ui-paragraph>
    <button (click)="closeModal()">
      <ui-icon name="close" fill="neutrals-900" m-size="24" size="24" />
    </button>
  </div>
  <div class="grid grid-cols-8 gap-2 items-center w-full mb-4">
    <div class="col-span-6 nav-list-items-container">
      <ul class="flex gap-6">
        <ng-container *ngFor="let item of navAnswersItems">
          <li
            [ngClass]="{ selected: item.active }"
            (click)="setActiveAAnswerType(item)"
          >
            <ui-headline
              type="h16"
              mobile-type="h16"
              font-weight="semibold"
              text-color="neutrals-900"
            >
              {{ item.description }}
            </ui-headline>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <div
    class="flex flex-col w-full items-center justify-center h-[310px]"
    *ngIf="isLoadingQuickAnswers"
  >
    <ui-loader type="secondary" size="2xl" *ngIf="isLoadingQuickAnswers" />
  </div>
  <div *ngIf="!isLoadingQuickAnswers" class="w-full flex flex-col h-[310px]">
    <div class="flex flex-col gap-7 overflow-y-auto h-[310px]">
      <div class="w-full" *ngFor="let answer of quickAnswersList">
        <div
          class="bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border flex justify-between p-3"
        >
          <div class="flex flex-col gap-2">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-700"
              font-weight="semibold"
            >
              {{ answer.type }}
            </ui-paragraph>

            <ui-paragraph
              type="p12"
              mobile-type="p12"
              text-color="neutrals-700"
              font-weight="regular"
              class="whitespace-pre-line"
            >
              {{ answer.message }}
            </ui-paragraph>
          </div>
          <div class="flex items-center justify-between gap-4">
            <button
              (click)="editQuickAnswers(answer)"
              class="ustify-center items-center flex"
            >
              <ui-icon name="edit" fill="neutrals-900" m-size="20" size="20" />
            </button>
            <button
              (click)="deleteQuickAnswers(answer)"
              class="ustify-center items-center flex"
            >
              <ui-icon
                name="delete"
                fill="neutrals-900"
                m-size="20"
                size="20"
              />
            </button>
          </div>
        </div>

        <form
          *ngIf="answer.isActivated && !isLoadingQuickAnswers"
          [formGroup]="form"
          class="document-form flex flex-col gap-1 bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border justify-between p-3"
          (submit)="onEditAnswer(answer)"
        >
          <div class="bg-[#F7F9FC] rounded-lg">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #inputTypeContainer
            >
              <input
                type="text"
                formControlName="type"
                placeholder="Título"
                (focus)="inputContainer.classList.add('focussed')"
                (blur)="inputContainer.classList.remove('focussed')"
                class="bg-[#F7F9FC]"
              />
            </div>
          </div>

          <div class="bg-[#F7F9FC] rounded-lg">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #inputContainer
            >
              <textarea
                formControlName="message"
                placeholder="Contenido de texto"
                (focus)="inputContainer.classList.add('focussed')"
                (blur)="inputContainer.classList.remove('focussed')"
                class="bg-[#F7F9FC] w-full resize-none focus:outline-none"
                rows="4"
              ></textarea>
            </div>
          </div>

          <div class="mt-[15px] justify-end items-end flex w-full">
            <button
              class="w-[201px] px-8 justify-center items-center flex rounded-md bg-unicon-yellow-100 h-12"
              type="submit"
            >
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                font-weight="semibold"
                *ngIf="!isLoading"
              >
                Confirmar
              </ui-paragraph>
              <ui-loader type="secondary" size="md" *ngIf="isLoading" />
            </button>
          </div>
        </form>
      </div>

      <form
        *ngIf="addQuickAnswer"
        [formGroup]="form"
        class="document-form flex flex-col gap-1 bg-neutrals-0 border-neutrals-400 rounded-[8px] box-border justify-between p-3"
        (submit)="onSubmit()"
      >
        <div class="bg-[#F7F9FC] rounded-lg">
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
            #inputTypeContainer
          >
            <input
              type="text"
              formControlName="type"
              placeholder="Título"
              (focus)="inputContainer.classList.add('focussed')"
              (blur)="inputContainer.classList.remove('focussed')"
              class="bg-[#F7F9FC]"
            />
          </div>
        </div>

        <div class="bg-[#F7F9FC] rounded-lg">
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
            #inputContainer
          >
            <textarea
              formControlName="message"
              placeholder="Contenido de texto"
              (focus)="inputContainer.classList.add('focussed')"
              (blur)="inputContainer.classList.remove('focussed')"
              class="bg-[#F7F9FC] w-full resize-none focus:outline-none"
              rows="4"
            ></textarea>
          </div>
        </div>

        <div class="mt-[15px] justify-end items-end flex w-full">
          <button
            class="w-[201px] px-8 justify-center items-center flex rounded-md bg-unicon-yellow-100 h-12"
            type="submit"
          >
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              font-weight="semibold"
              *ngIf="!isLoading"
            >
              Confirmar
            </ui-paragraph>
            <ui-loader type="secondary" size="md" *ngIf="isLoading" />
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="mt-[20px] justify-end items-end flex w-full mb-6">
    <button
      (click)="addQuickAnswers()"
      class="w-[201px] px-8 justify-center items-center flex gap-2 rounded-md bg-unicon-yellow-100 h-12"
    >
      <ui-icon name="plus" fill="neutrals-900" m-size="20" size="20" />
      <ui-paragraph type="p14" mobile-type="p14" text-color="neutrals-900">
        Agregar
      </ui-paragraph>
    </button>
  </div>
</div>
